import React, { Component } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import { FaListAlt } from "react-icons/fa";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import COLORS from "scss/colors.module.scss";
import GroupSubMenu from "./GroupSubMenu";
import GroupColumnsList from "./GroupColumsList";
import StyledMenu from "./StyledMenu";
import { observer } from "mobx-react";
import { Tooltip } from "@material-ui/core";
import SelectMultiLevel from "app/common/components/input/Menu/SelectMultiLevel";
import styled, { css } from "styled-components";
import { StyledTooltip } from "app/common/utils/StyledTooltip";

const useStyles = (theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
    backgroundColor: "transparent",
  },

  dropdown: {
    backgroundColor: "transparent",
    fontWeight: 400,
  },

  menuUnselected: {
    color: "black",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },

  menuSelected: {
    backgroundColor: "#eaddeb",
    "&:hover": {
      boxShadow: "inset 0px 0px 0px 2px #d2b8d4",
      boxSizing: "border-box",
      backgroundColor: "#eaddeb",
    },
  },

  menuClicked: {
    color: "black",
    backgroundColor: "#efefef",
    "&:hover": {
      backgroundColor: "#efefef",
    },
  },

  paper: {
    "& .MuiPaper-root": {
      backgroundColor: "#ffffff",
    },
  },
});

const groupOptions = [
  { value: "Date", key: "d" },
  { value: "Month", key: "m" },
  { value: "Month-Year", key: "my" },
  { value: "Year", key: "y" },
];

class Group extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      groupedColumns: [],
      groupedColumnNames: [],
      rowGroupIndex: 0,
      anchorEl: null,
      isShowSubMenu: false,
      isShowDateOptionsMenu: false,
      selectedAnchorEl: false,
      selectedColumnIndex: -1,
      searchtext: "",
      selectedOption: -1,
      isButtonTextOverFlown: false,
    };
    this.groupColumn = this.groupColumn.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.closeSubMenu = this.closeSubMenu.bind(this);
    this.closeDateOptionsMenu = this.closeDateOptionsMenu.bind(this);
    this.changeGroupOption = this.changeGroupOption.bind(this);
    this.buttonTextRef = React.createRef();
  }

  updateButtonTextOverFlowStatus() {
    if (this.buttonTextRef && this.buttonTextRef.current) {
      setTimeout(() => {
        let isTextOverFlown =
          this.buttonTextRef?.current?.scrollWidth >
          this.buttonTextRef?.current?.clientWidth;
        if (
          typeof isTextOverFlown !== "undefined" &&
          isTextOverFlown !== this.state.isButtonTextOverFlown
        ) {
          this.setState({ isButtonTextOverFlown: isTextOverFlown });
        }
      }, 1);
    }
  }

  componentDidUpdate() {
    this.updateButtonTextOverFlowStatus();
  }

  updateColumnDefsGrouping = (colId, groupingIndex, replace) => {
    const previousShouldLoadAllRows = this.props.store.shouldLoadAllRows;

    for (let i = 0; i < this.props.store.columnDefs.length; i++) {
      if (colId === this.props.store.columnDefs[i]["colId"]) {
        this.props.store.columnDefs[i]["rowGroup"] = !this.props.store
          .columnDefs[i]["rowGroup"];
        this.props.store.columnDefs[i]["rowGroupIndex"] = groupingIndex;
        if (
          groupingIndex == null &&
          (this.props.store.columnDefs[i].cellRendererParams?.columnTypeId ==
            "4" ||
            this.props.store.columnDefs[i].cellRendererParams?.columnTypeId ==
              "16")
        ) {
          this.props.store.columnDefs[i]["rowGroupOption"] = "my";
        }
        this.updateColumnDefsKeyCreator(i);

        break;
      }
    }

    this.props.updateGrid(previousShouldLoadAllRows);
  };

  replaceColumnDefsGrouping = (colIdToReplace, colId, groupingIndex) => {
    const previousShouldLoadAllRows = this.props.store.shouldLoadAllRows;

    for (let i = 0; i < this.props.store.columnDefs.length; i++) {
      if (colId === this.props.store.columnDefs[i]["colId"]) {
        this.props.store.columnDefs[i]["rowGroup"] = true;
        this.props.store.columnDefs[i]["rowGroupIndex"] = groupingIndex;
        this.updateColumnDefsKeyCreator(i);
      } else if (colIdToReplace === this.props.store.columnDefs[i]["colId"]) {
        this.props.store.columnDefs[i]["rowGroup"] = false;
        this.props.store.columnDefs[i]["rowGroupIndex"] = null;
        this.updateColumnDefsKeyCreator(i);
      }
    }

    this.props.updateGrid(previousShouldLoadAllRows);
  };

  updateColumnDefsKeyCreator(index) {
    this.props.store.columnDefs[index].keyCreator = (params) => {
      if(params.value !== '+r0w'){
        return this.props.store.getKeyCreatorValue(
          params,
          this.props.store.columnDefs[index]
        );
      }
    };
  }

  updateGrid(previousShouldLoadAllRows) {
    if (!previousShouldLoadAllRows && this.props.store.shouldLoadAllRows) {
      this.props.redrawGrid();
      this.props.gridApi.showLoadingOverlay();
      return;
    }

    this.props.gridApi.showLoadingOverlay();
    this.props.gridApi.setColumnDefs([]);
    this.props.gridApi.setColumnDefs(this.props.store.columnDefs);
    this.props.store.setAllRowsData({ api: this.props.gridApi });
  }

  getColumns() {
    const columns = this.props.store.columnDefs
      .filter(col => col.colId !== "+" && col.colId !== "Id" && col.colId !== "Actions" && col.colId !== "userEvents" && col.colId !== "commentsId")
      .map((col, index) => {
        let rowgroup = groupOptions.filter(
          (option) => option.key === col.rowGroupOption
        );
        let optionName = "";
        if (rowgroup.length > 0) {
          optionName = rowgroup[0].value;
        }
        // if (
        //   optionName.length == 0 &&
        //   (parseInt(col.cellRendererParams.columnTypeId) == 4 ||
        //     parseInt(col.cellRendererParams.columnTypeId) == 16)
        // ) {
        //   optionName = groupOptions[0].value;
        //   col.rowGroupOption = groupOptions[0].key;
        //   let index = this.props.store.columnDefs.findIndex(
        //     (element) => element.colId == col.colId
        //   );

        //   this.updateColumnDefsKeyCreator(index);
        // }
        return {
          label: col.headerName,
          value: col.colId,
          isGrouped: col.rowGroup ?? false,
          rowGroupIndex: col.rowGroupIndex,
          index: index,
          rowGroupOption: optionName,
        };
      });

    const groupedColumns = columns
      .filter((col) => col.isGrouped)
      .sort((a, b) => {
        if (a.rowGroupIndex < b.rowGroupIndex) {
          return -1;
        }
        if (a.rowGroupIndex > b.rowGroupIndex) {
          return 1;
        }
        return 0;
      });
    const groupedColumnValues = groupedColumns.map((col) => col.value);
    return { columns, groupedColumns, groupedColumnValues };
  }

  expandAllGroups(expand) {
    this.props.gridApi.forEachNode((node) => {
      node.expanded = expand;
    });
    this.props.gridApi.onGroupExpandedOrCollapsed();
  }

  groupColumn(colId, group, replace, indexOfExistence) {
    var { columns, groupedColumns, groupedColumnValues } = this.getColumns(),
      rowGroupIndex = this.state.rowGroupIndex;

    let maximumRowgroupIndex = 0;
    for (let i = 0; i < groupedColumns.length; i++) {
      if (groupedColumns[i].rowGroupIndex > maximumRowgroupIndex) {
        maximumRowgroupIndex = groupedColumns[i].rowGroupIndex
      }
    }
    rowGroupIndex = maximumRowgroupIndex;

    for (let i = 0; i < columns.length; i++) {
      if (replace) {
        var replacableColId = groupedColumnValues[indexOfExistence];
        if (columns[i].value === replacableColId) {
          this.replaceColumnDefsGrouping(
            columns[i].value,
            colId,
            columns[i].rowGroupIndex
          );
          break;
        }
      } else {
        if (columns[i].value === colId) {
          if (group) {
            rowGroupIndex = rowGroupIndex + 1;
            this.updateColumnDefsGrouping(columns[i].value, rowGroupIndex);
          } else {
            this.updateColumnDefsGrouping(columns[i].value, null);
          }
          break;
        }
      }
    }
    this.setState({
      rowGroupIndex: rowGroupIndex,
    });
  }

  handleMenuClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  handleMenuClose() {
    this.setState({
      anchorEl: null,
    });
  }

  pickAField = (event) => {
    this.showSubMenu(event.currentTarget);
  };

  showSubMenu = (targrt) => {
    this.setState({
      selectedAnchorEl: targrt,
      isShowSubMenu: true,
      searchtext: "",
    });
  };

  closeSubMenu() {
    this.setState({
      selectedAnchorEl: null,
      isShowSubMenu: false,
      selectedColumnIndex: -1,
    });
  }
  closeDateOptionsMenu() {
    this.setState({
      selectedAnchorEl: null,
      isShowDateOptionsMenu: false,
      selectedColumnIndex: -1,
    });
  }

  itemSelected(object) {
    if (this.state.selectedColumnIndex != -1) {
      this.groupColumn(
        object.value,
        true,
        true,
        this.state.selectedColumnIndex
      );
      this.setState({
        selectedColumnIndex: -1,
      });
    } else {
      this.groupColumn(object.value, true, undefined, undefined);
    }
    this.closeSubMenu();
  }

  changeGroupOption(option) {
    var { columns, groupedColumns, groupedColumnValues } = this.getColumns(),
      rowGroupIndex = this.state.rowGroupIndex;
    let groupedColumn = groupedColumns[this.state.selectedColumnIndex];
    const previousShouldLoadAllRows = this.props.store.shouldLoadAllRows;

    for (let i = 0; i < this.props.store.columnDefs.length; i++) {
      if (groupedColumn.value === this.props.store.columnDefs[i]["colId"]) {
        this.props.store.columnDefs[i]["rowGroupOption"] = option.key;
        this.updateColumnDefsKeyCreator(i);
      }
    }
    this.setState({
      selectedColumnIndex: -1,
    });
    this.props.updateGrid(previousShouldLoadAllRows);

    this.closeDateOptionsMenu();
  }

  changeColumn(index, target) {
    this.setState({
      selectedColumnIndex: index,
    });
    this.showSubMenu(target);
  }

  deleteColumn(column) {
    this.groupColumn(column.value, false);
  }

  showDateGroupOptions(index, target) {
    this.setState({
      selectedColumnIndex: index,
      selectedAnchorEl: target,
      isShowDateOptionsMenu: true,
      searchtext: "",
    });
  }

  render() {
    const { classes } = this.props;
    const { columns, groupedColumns, groupedColumnValues } = this.getColumns();
    let groupedColumnNames = groupedColumns.map((col) => col.label);

    const isDisabled = this.props.store.isLazyLoadEnabled;

    const buttonText =
      groupedColumns.length === 0
        ? "Group"
        : "Grouped by " +
        groupedColumns.length +
        " field" +
        (groupedColumns.length > 1 ? "s" : "");

    return (
      <div style={{ margin: 3 }}>
        <StyledTooltip
          title={
            isDisabled ? "Grouping is temporarily disabled for this view" : buttonText
          }
          // disableHoverListener={
          //   isDisabled ? false : (window.screen.width <= 1401 ? !this.state.isButtonTextOverFlown : true)
          // }
          disableHoverListener={
            isDisabled ? false : !this.state.isButtonTextOverFlown
          }
        >
          <span>
            <StyledButton
              screenWidth={window.screen.width}
              highlighted={groupedColumns.length != 0}
              className={
                groupedColumns.length == 0
                  ? this.state.anchorEl == null
                    ? classes.menuUnselected
                    : classes.menuClicked
                  : classes.menuSelected
              }
              onClick={this.handleMenuClick}
              startIcon={<FaListAlt />}
              disabled={isDisabled}
            >
              <StyledText
                ref={this.buttonTextRef}
                screenWidth={window.screen.width}
              >
                {buttonText}
              </StyledText>
            </StyledButton>
          </span>
        </StyledTooltip>
        <StyledMenu
          id="customized-menu"
          anchorEl={this.state.anchorEl}
          keepMounted
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleMenuClose}
          className={classes.paper}
        >
          <div>
            <GroupColumnsList
              groupedColumns={groupedColumns}
              groupedColumnNames={groupedColumnNames}
              changeColumn={(index, target) => {
                this.changeColumn(index, target);
              }}
              deleteColumn={(column) => {
                this.deleteColumn(column);
              }}
              changeGroupOptions={(index, target) => {
                this.showDateGroupOptions(index, target);
              }}
            />

            {/* {setMenuColumns()} */}
            <div className={classes.root}>
              <Button
                className={classes.dropdown}
                endIcon={<ArrowDropDownIcon />}
                onClick={this.pickAField}
                style={{ fontSize: 13 }}
              >
                Pick a field to group by
              </Button>

              <Button
                onClick={() => {
                  this.expandAllGroups(true);
                }}
              >
                Expand all
              </Button>
              <Button
                onClick={() => {
                  this.expandAllGroups(false);
                }}
              >
                Collapse all
              </Button>
            </div>
          </div>
        </StyledMenu>
        {this.state.isShowSubMenu && (
          <GroupSubMenu
            anchorEl={this.state.selectedAnchorEl}
            closeMenu={this.closeSubMenu}
            itemSelected={(object) => {
              this.itemSelected(object);
            }}
            columns={columns}
            groupedColumns={groupedColumnValues}
            searchTextChanged={(text) => {
              this.setState({ searchtext: text });
            }}
            searchtext={this.state.searchtext}
          />
        )}
        {this.state.isShowDateOptionsMenu && (
          <GroupSubMenu
            anchorEl={this.state.selectedAnchorEl}
            closeMenu={this.closeDateOptionsMenu}
            itemSelected={(object) => {
              this.changeGroupOption(object);
            }}
            columns={groupOptions}
            groupedColumns={[]}
            searchTextChanged={(text) => {
              this.setState({ searchtext: text });
            }}
            searchtext={this.state.searchtext}
            hideSearchBar={true}
          />
        )}
      </div>
    );
  }
}

const StyledButton = styled(Button)`
  ${(props) =>
    // props.screenWidth <= 1401 &&
    // props.highlighted &&
    css`
      max-width: 100px;
    `}
`;

const StyledText = styled.span`
  ${(props) =>
    // props.screenWidth <= 1401 &&
    css`
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    `}
`;


export default withStyles(useStyles)(observer(Group));
